import { appName } from '../../../../config/uri';

const tr = {
  corporation: {
    attributes: {
      id: 'Id',
      country: 'País',
      name: 'Nome',
      email: 'Email',
      phone: 'Telefone',
      cnpj: 'CNPJ',
      city: 'Cidade',
      city_id: 'Cidade',
      street: 'Rua',
      district: 'Bairro',
      number: 'Número',
      postal_code: 'CEP',
      contact_name: 'Contato',
      contact_phone: 'Telefone do Contato',
      contract_expires_at: 'Expiração contrato',
      owners: 'Usuários responsáveis',
      is_driving: 'Direção inteligente',
      is_doctor: `${appName} Médico`,
      is_doctor_all: 'Médicos especialistas',
      is_emergency: 'Botão de Panico',
      disabled_at: 'Desativado em',
      users_limit: 'Limite de usuários',
      is_plan: 'Localização',
      frozen_at: 'Congelado em',
      corporation: 'Empresa',
      corporation_id: 'Empresa',
      specialties: 'Especialidades',
      noSpecialties: 'Não há especialidades',
      noPacks: 'Não há pacotes',
      user: 'Usuário',
      packs: 'Adicionais',
      activePacks: 'Adicionais ativos',
      packPackages: 'Pacotes',
      corporationFather: 'Empresa matriz',
      corporationNoFather: 'Esta empresa é uma matriz',
      required_cns: 'Obriga CNS?',
      required_location: 'Obriga Localização?',
      required_documents: 'Obriga Documentos?',
      has_benefits_club: 'Habilitar Club Televida?',
      required_email: 'Obriga cadastro de Email?',
      user_welcome_email: 'Enviar e-mail automático de boas-vindas?',
      corporation_type: 'Tipo de Corporação',
      wallet_id: 'ID da Carteira (Asaas)',
      landing_url: 'ID da Landing Page',
      accession_percentage: 'Percentual de Adesão (%)',
      signature_percentage: 'Percentual de Assinatura (%)',
      income_value: 'Receita (R$)',
      linked_corporations: 'Empresas vinculadas',
    },
    extras: {
      create_corporation: 'Nova empresa',
      edit_corporation: 'Editando empresa',
      show_corporation: 'Visualizando empresa',
      delete_corporation: 'Excluir empresa',
      users: 'Usuários vinculados',
      addUser: '+ Vincular usuário',
      addUserRelation: 'Novo vínculo de usuário',
      freeze: 'Congelar',
      unfreeze: 'Descongelar',
      desactive: 'Desativar',
      active: 'Ativar',
      isInactive: 'Inativo',
      isActive: 'Ativo',
      frozenSince: 'Congelada desde',
      desactiveSuccess: 'Desativada com sucesso',
      desactiveError: 'Não foi possível inativar',
      frozenSuccess: 'Congelada com sucesso',
      frozenError: 'Não foi possível congelar',
      activeSuccess: 'Ativado com sucesso',
      activeError: 'Não foi possível ativar',
      unFreezeSuccess: 'Descongelado com sucesso',
      unFreezeError: 'Não foi possível descongelar',
      desactiveConfirm: 'Tem certeza que deseja inativar a empresa?',
      freezeConfirm: 'Tem certeza que deseja congelar a empresa?',
      removeUser:
        'Tem certeza que deseja desvinvular este usuário e seus dependentes?',
      activePackageUser:
        'Tem certeza que deseja ativar {{package}} para este usuário?',
      removePackageUser:
        'Tem certeza que deseja desativar {{package}} para este usuário?',
      activePackageSuccess: 'Adicional habilitado com sucesso!',
      removePackageSuccess: 'Adicional removido com sucesso!',
      addUserSuccess: 'Usuário vinculado com sucesso!',
      addUserError: 'Erro ao vincular o usuário!',
      selectUser: 'É necessário selecionar um usuário',
      showPayments: 'Visualizar faturamento',
      savePaymets: 'Faturar',
      syncQuestorText:
        'Realmente deseja faturar este dados com o Questor Empresarial?',
      syncQuestorSuccess: 'Faturamento gerado com sucesso!',
      syncQuestorFail: 'Não foi possível gerar o faturamento',
      rejectDocs: 'Todas as imagens serão excluídas.',
    },
    dialog: {
      full_name: 'Nome Completo',
      cpf: 'CPF',
      email: 'E-MAIL',
      phone: 'FONE',
      external_id: 'ID EXTERNO',
      relation_external_id: 'ID EXTERNO RELACIONADO',
      upload: 'Carregar Planilha',
    },
    tabs: {
      data: 'Dados',
      users: 'Usuários vinculados',
      financial: 'Faturamento',
    },
    defSingular: 'Empresa',
    defPlural: 'Empresas',
  },
};

export default tr;
